import {
  Box,
  Card,
  CardBody,
  Divider,
  Flex,
  Grid,
  Heading,
  Icon,
  Stack,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { ReceiptLongOutlined } from '@mui/icons-material';
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';

interface PaymentProofSummaryProps {
  bankName: string;
  bankAccount: string;
  proofs: Array<{ url: string }>;
  onPreview: (url: string) => void;
}

export const PaymentProofSummary = ({
  bankName,
  bankAccount,
  proofs,
  onPreview,
}: PaymentProofSummaryProps) => {
  if (!proofs.length) {
    return null;
  }

  return (
    <Card
      shadow="none"
      borderRadius="md"
      borderWidth="1px"
      borderColor="rgba(217, 217, 217, 1)"
      id="submit-payment-proof"
      scrollMarginTop="10rem"
    >
      <CardBody>
        <Stack>
          <Flex alignItems="center" gap="2">
            <Icon as={ReceiptLongOutlined} color="blue" />
            <Heading fontSize={{ base: 'lg', md: 'xl' }}>
              Bukti Pembayaran
            </Heading>
          </Flex>
          <Stack py={2}>
            <Divider borderColor="gray.33" borderWidth="3px" variant="dashed" />
          </Stack>
          <Grid
            templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
            gap={6}
            w="full"
          >
            <Stack spacing={4} minWidth={{ lg: '50%' }}>
              <Stack direction="column">
                <Text fontSize="md" color="gray.75">
                  Nama Bank
                </Text>
                <Text as="b" mt="0 !important">
                  {bankName}
                </Text>
              </Stack>
              <Stack direction="column">
                <Text fontSize="md" color="gray.75">
                  Nama Pemilik Rekening
                </Text>
                <Text as="b" mt="0 !important">
                  {bankAccount}
                </Text>
              </Stack>
            </Stack>
            <Stack>
              <Text fontSize="md" color="gray.75">
                Bukti Transfer
              </Text>
              <Grid
                templateColumns={{
                  base: 'repeat(3, 1fr)',
                  md: 'repeat(2, 1fr)',
                  xl: 'repeat(3, 1fr)',
                }}
                gap={4}
                maxW="full"
                overflowX="auto"
                height={{ base: 56, md: 60 }}
              >
                {proofs.map((item, index) => {
                  const fileName =
                    item?.url.length > 10
                      ? `${item?.url.slice(-10)}`
                      : item?.url;

                  return (
                    <Stack
                      key={`${item.url}-${index}`}
                      textAlign="center"
                      fontSize={{ base: '12px', md: '16px' }}
                    >
                      <Stack direction="row" justifyContent="center">
                        <Box _hover={{ cursor: 'pointer' }}>
                          <Icon
                            as={InsertDriveFileOutlined}
                            height={{ base: 10, md: '66px' }}
                            width={{ base: 10, md: '66px' }}
                            padding={2}
                            bgColor="gray.33"
                            color="blue"
                            borderRadius="md"
                            onClick={() => onPreview(item.url)}
                          />
                        </Box>
                      </Stack>
                      <Tooltip label={item.url} hasArrow>
                        {fileName}
                      </Tooltip>
                    </Stack>
                  );
                })}
              </Grid>
            </Stack>
          </Grid>
        </Stack>
      </CardBody>
    </Card>
  );
};
